import type { ListItemRow } from '../../db/types';
import { ItemText } from './ItemText';
import { CHIP_CLS, statusChip } from './status';

interface Props {
  item: ListItemRow;
  /** Brak = wiersz tylko do odczytu (zakończona lista). */
  onOpen?: () => void;
  /** Kto odhaczył, gdy to nie ja: imię (do opisu) i inicjał (kółko). */
  by?: { name: string; initial: string } | null;
  /** Propozycja zamiennika — poza przyciskiem wiersza, bo ma własne przyciski. */
  banner?: React.ReactNode;
  price?: string | null;
}

/** Pozycja odhaczona: wyciszona nazwa i status; tapnięcie otwiera opcje (zmiana statusu, przywrócenie). */
export function DoneRow({ item, onOpen, by = null, banner, price = null }: Props) {
  const chip = statusChip(item);
  const body = (
    <>
      <ItemText item={item} muted price={price} />
      <span className="flex max-w-[50%] shrink-0 items-center gap-1.5">
        <span className={`truncate rounded-full px-2.5 py-1 text-sm font-medium ${CHIP_CLS[chip.tone]}`}>{chip.text}</span>
        {by && (
          <span
            title={`Odhaczone: ${by.name}`}
            aria-label={`odhaczone: ${by.name}`}
            className="flex size-6 shrink-0 items-center justify-center rounded-full bg-stone-200 text-xs font-semibold text-stone-700 dark:bg-stone-700 dark:text-stone-200"
          >
            {by.initial}
          </span>
        )}
      </span>
    </>
  );
  const cls = 'flex min-h-14 w-full items-center gap-3 px-4 text-left';
  return (
    <div className="border-b border-stone-200 bg-white dark:border-stone-800 dark:bg-stone-900">
      {onOpen ? (
        <button type="button" onClick={onOpen} className={`${cls} active:bg-stone-100 dark:active:bg-stone-800`}>
          {body}
        </button>
      ) : (
        <div className={cls}>{body}</div>
      )}
      {banner && <div className="px-4 pb-2.5 -mt-1">{banner}</div>}
    </div>
  );
}
